export enum ListsActionTypes {
  SET_LOADING = "SET_LOADING",
  SET_ERROR = "SET_ERROR",
  SET_CREATING_FAVORITE_LIST = "SET_CREATING_FAVORITE_LIST",
  ADD_LIST = "ADD_LIST",
  UPDATE_LIST = "UPDATE_LIST",
  DELETE_LIST = "DELETE_LIST",
  UPDATE_LIST_ITEMS = "UPDATE_LIST_ITEMS",
  SET_YOUR_LISTS = "SET_YOUR_LISTS",
  SET_PUBLIC_LISTS = "SET_PUBLIC_LISTS",
  SET_SHARED_LISTS = "SET_SHARED_LISTS",
  SET_SHARED_WITH_YOU_LISTS = "SET_SHARED_WITH_YOU_LISTS",
}

export enum ListType {
  YOUR_LISTS = "yourLists",
  PUBLIC_LISTS = "publicLists",
  SHARED_LISTS = "sharedLists",
  SHARED_WITH_YOU_LISTS = "sharedWithYouLists",
}
